import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useStore } from "@/context/Store";
import { http, errMsg } from "@/lib/api";

export default function PaymentResult() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const { clear } = useStore();
  const [msg, setMsg] = useState("");
  useEffect(() => {
    http.post(`/orders/${sp.get("oid")}/verify`).then(({ data }) => {
      if (data.status === "paid") { clear(); nav(`/account?order=${data.order_number}&email=${encodeURIComponent(data.email)}&placed=1`, { replace: true }); }
      else setMsg(`Payment ${data.status === "active" ? "not completed" : data.status}. Your bag is saved, so you can try again.`);
    }).catch((e) => setMsg(errMsg(e, "We couldn't confirm your payment.")));
  }, []); // eslint-disable-line
  return (
    <div className="py-40 text-center" data-testid="payment-result">
      {msg ? <><p className="serif text-3xl">{msg}</p><Link to="/checkout" className="btn btn-ox mt-6">Back to checkout</Link></> : <><Loader2 className="w-8 h-8 animate-spin mx-auto text-[var(--rose-deep)]" /><p className="serif text-2xl mt-4">Confirming your payment…</p></>}
    </div>
  );
}
